<sui-dialog-header class="header" (closeButtonClick)="onCloseButtonClick()">
  이 그룹책을 함께읽기 중이에요
</sui-dialog-header>
<p class="description">
  지금 뷰어에 접속 중인 사용자는 프로필 위에 하늘색 도트로 표시됩니다.
</p>
<div class="divider"></div>
<div class="body">
  <div class="list-header">
    전체 {{ _totalMemberCount }}명/ 현재 접속 중 <b>{{ _onlineMemberCount }}</b
    >명
  </div>
  <div class="list" #listElem>
    <div
      class="list-item"
      *ngFor="let member of _members"
      [class.is-selected]="_selectedMemberId === member.id"
    >
      <div class="member">
        <sui-reading-group-member
          [member]="member"
          [isOnline]="member.isOnline || !!member.is_me"
          [class.is-clickable]="!member.is_me"
          (click)="!member.is_me && _onClickAvatar(member)"
        ></sui-reading-group-member>
        <sui-rounded-tag *ngIf="member.is_owner">만든이</sui-rounded-tag>
      </div>
      <div class="member-actions">
        <button
          *ngIf="!member.is_follow && !member.is_me"
          class="follow-button"
          (click)="_followMember(member)"
        >
          팔로우
        </button>
        <button
          *ngIf="member.is_follow && !member.is_me"
          class="follow-button"
          (click)="_unfollowMember(member)"
        >
          언팔로우
        </button>
        <button
          class="message-button cancel"
          *ngIf="!member.is_me"
          (click)="_sendMessageToMember(member)"
        >
          쪽지 보내기
        </button>
      </div>
    </div>
  </div>
</div>
